import { FieldLanguagesResponse } from './types'

export const fieldLanguages = (raw: any): FieldLanguagesResponse => ({
  data: raw,
})
